import { escapeRegex } from '../../regex'
import { Track } from '../../../classes/track'
import { TrackFields } from '../../../constants'

export function findTracksWithCharacter(tracks: Track[], characters: string) {
  const split = characters.split('')

  return tracks.filter(t => split.some(s => t.title && t.title.includes(s)))
}

export function replaceCharacters(track: any, values: any[]): string {
  const field: TrackFields = values[0]
  const characters: string = values[1]

  let s: string = track[field]
  const split = characters.split('')

  for (const t of split) {
    s = s.replace(new RegExp(escapeRegex(t), 'g'), ' ').trim()
  }

  return s
}
